import { Box, Container, Paper } from "@mui/material";
// import Logo from "Assets/svgs/logo.svg"; // replace path as needed
import Logo from "Assets/images/logo.png";

import { Typography, Button } from "Atoms";
import { ArrowBack, Logout } from "@mui/icons-material";
import Users, { UserRow } from "./Users";
import { useBoundStore } from "Zustand/store/mainStore";

const demoRows: UserRow[] = [
  {
    id: "1",
    firstName: "Alpha",
    lastName: "Beta",
    type: "Administrator",
    email: "AlphaTest",
    status: "aktiv",
  },
  {
    id: "2",
    firstName: "testali",
    lastName: "raza",
    type: "Führungskraft",
    email: "mealiraza17@gmail.comm",
    status: "aktiv",
  },
  {
    id: "3",
    firstName: "kaka",
    lastName: "g",
    type: "Führungskraft",
    email: "kakag",
    status: "inaktiv",
  },
  {
    id: "4",
    firstName: "Sophie",
    lastName: "Müller",
    type: "Mitarbeiter",
    email: "sophie.mueller@example.com",
    status: "aktiv",
  },
  {
    id: "5",
    firstName: "Liam",
    lastName: "Schmidt",
    type: "Administrator",
    email: "liam.schmidt@example.com",
    status: "inaktiv",
  },
  {
    id: "6",
    firstName: "Aylin",
    lastName: "Kaya",
    type: "Führungskraft",
    email: "aylin.kaya@example.com",
    status: "aktiv",
  },
  {
    id: "7",
    firstName: "David",
    lastName: "Nguyen",
    type: "Mitarbeiter",
    email: "david.nguyen@example.com",
    status: "aktiv",
  },
  {
    id: "8",
    firstName: "Fatima",
    lastName: "Ali",
    type: "Führungskraft",
    email: "fatima.ali@example.com",
    status: "inaktiv",
  },
  {
    id: "9",
    firstName: "Jonas",
    lastName: "Weber",
    type: "Administrator",
    email: "jonas.weber@example.com",
    status: "aktiv",
  },
  {
    id: "10",
    firstName: "Elena",
    lastName: "Petrova",
    type: "Mitarbeiter",
    email: "elena.petrova@example.com",
    status: "aktiv",
  },
];

export default function UsersPage() {
  const {
    logout,
    // getProjectByNodeId,
  } = useBoundStore();

  return (
    <Container
      maxWidth="xl"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        padding: "0px !important",
        margin: "0px !important",
      }}
    >
      <Paper sx={{ width: "100%", p: 4, borderRadius: 2 }} elevation={2}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Button
            variant="text"
            onClick={() => {
              window.history.back();
            }}
            startIcon={<ArrowBack />}
          >
            Back
          </Button>

          <Box
            display="flex"
            alignItems="center"
            gap={1}
            flexDirection={"column"}
          >
            <img src={Logo} alt="Logo" style={{ height: 40 }} />
            <Box>
              <Typography variant="h6" color="text.secondary">
                ADMIN
              </Typography>
            </Box>
          </Box>
          <Button
            variant="outlined"
            size="small"
            color="error"
            onClick={logout}
            startIcon={<Logout />}
          >
            Logout
          </Button>
        </Box>
        <Users
          rows={demoRows}
          onCreate={() => {
            /* open create modal */
          }}
          onEdit={(u) => {
            /* open edit modal with u */
          }}
          onDelete={(u) => {
            /* confirm + call API */
          }}
        />
      </Paper>
    </Container>
  );
}
